// Created from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
export enum I2gInputFieldAutocompleteType {
  on = 'on',
  off = 'off',
  fullName = 'name',
  firstName = 'given-name',
  middleName = 'additional-name',
  lastName = 'family-name',
  email = 'email',
  newPassword = 'new-password',
  currentPassword = 'current-password',
  mfaCode = 'one-time-code',
  country = 'country',
  postalCode = 'postal-code',
  url = 'url',
  telNational = 'tel-national',
}
